<template>
    <div class="mb-3">
        <template v-if="option.required">
            <div class="pl-4 pb-1">
                <strong>{{ option.label }}</strong>
                <div class="text-muted fs-7">
                    <div>Obligatoire.</div>
                    {{ option.description }}
                </div>
            </div>
        </template>
        <template v-else>
            <component :is="component" class="pl-4" :value="option.id" :disabled="option.gauge === 0">
                {{ option.label }}
                <div class="font-weight-normal text-muted fs-7">
                    <template v-if="option.gauge === 0">
                        <div>Complet.</div>
                    </template>
                    {{ option.description }}
                </div>
            </component>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            option: Object,
            component: null,
        }
    }
</script>
